'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('./../../components');

var _HelpButton = require('./../../components/HelpButton/HelpButton');

var _LanguageDropdown = require('./../../components/LanguageDropdown/LanguageDropdown');

var _CenterViewApp = require('./CenterViewApp.scss');

var _CenterViewApp2 = _interopRequireDefault(_CenterViewApp);

var _Product = require('../../helpers/Product');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CenterViewApp = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CenterViewApp, _Component);

  function CenterViewApp() {
    (0, _classCallCheck3.default)(this, CenterViewApp);
    return (0, _possibleConstructorReturn3.default)(this, (CenterViewApp.__proto__ || (0, _getPrototypeOf2.default)(CenterViewApp)).apply(this, arguments));
  }

  (0, _createClass3.default)(CenterViewApp, [{
    key: 'getLanguageDropdown',
    value: function getLanguageDropdown() {
      var element = '';
      if (!this.props.auth.isMobile) {
        element = _react2.default.createElement(_components.LanguageDropdown, { className: _LanguageDropdown.lightGray + (this.props.hasHelp ? ' ' + _LanguageDropdown.helpClass : '') });
      }
      return element;
    }
  }, {
    key: 'getHelp',
    value: function getHelp() {
      var element = '';
      if (this.props.hasHelp && !this.props.auth.isMobile) {
        element = _react2.default.createElement(_components.HelpButton, { className: _HelpButton.rightHelp });
      }
      return element;
    }
  }, {
    key: 'render',
    value: function render() {
      var auth = this.props.auth;


      var dropdownElement = null;
      var helpElement = null;

      if (auth.productName === _Product.PRODUCT_NAMES.Music) {
        dropdownElement = this.getLanguageDropdown();
        helpElement = this.getHelp();
      }

      return _react2.default.createElement(
        'div',
        { className: _CenterViewApp2.default.content },
        _react2.default.createElement(
          'div',
          { className: _CenterViewApp2.default.app },
          _react2.default.createElement(
            'div',
            { className: _CenterViewApp2.default.appContent },
            this.props.children
          )
        )
      );
    }
  }]);
  return CenterViewApp;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  children: _react.PropTypes.object.isRequired,
  hasHelp: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = CenterViewApp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CenterViewApp/CenterViewApp.js
// module id = 1946
// module chunks = 0